import React, { useState, useRef, useEffect } from "react";
import { useMutation, useQuery } from "@tanstack/react-query";
import DeleteIcon from "@mui/icons-material/Delete";
import CampaignIcon from "@mui/icons-material/Campaign";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import axiosConfig from "../../../axios/axiosConfig";
import ReactHotToaster from "../../common/ReactHotToaster";
import MuiModal from "../../muiComps/MuiModal";
import TinyMCEEditor from "./TinyMCEEditor";
import TinyMCEContentTable from "./TinyMCEContentTable";
import {
  fetchBannerScreensList,
  fetchUserTypeList,
} from "../../common/UploadBannerForm";
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  IconButton,
  ListItemText,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import axios from "axios";

const initialInputDetails = {
  marqueeName: "",
  marqueeDesc: "",
  marqueeType: "",
  activateDate: "",
  expiryDate: "",
};

export const CreateMarqueeForm = () => {
  const [inputDetails, setInputDetails] = useState(initialInputDetails);
  const { marqueeName, marqueeDesc, marqueeType, activateDate, expiryDate } =
    inputDetails;

  const { user } = useSelector((state) => state.auth);
  const USERID = user?.userDetails?.id;

  const editorRef = useRef(null); // STATE FOR TINYMCE EDITOR
  const [marqueeList, setMarqueeList] = useState([]);
  const [selectedScreenInput, setSelectedScreenInput] = useState("");
  const [openTinyEditor, setOpenTinyEditor] = useState(false);
  const [bannerScreensList, setBannerScreensList] = useState([]);
  const [popupContentList, setPopupContentList] = useState([]);
  const [userTypes, setUserTypes] = useState([]);
  const [selectedUser, setSelectedUser] = useState([]);

  const [screenOptions, setScreenOptions] = useState([]);
  const [selectedScreenId, setSelectedScreenId] = useState("");
  const screenMap = {
    Dashboard: "Screener Screen",
    homescreen: "Home Screen",
    watchlistscreen: "Watchlist Screen",
    niftyfiftyscreen: "NiftyFifty Screen",
    detailpage: "Stock Details Screen",
    discount_floating: "discount_floating",
    trophy_floating: "trophy_floating",
  };
  useEffect(() => {
    const getBannerScreensList = async () => {
      const data = await fetchBannerScreensList();
      const filterScreen = data?.response
        ?.filter((item) => screenMap.hasOwnProperty(item?.screen_name))
        .map((item) => ({
          ...item,
          screen_name_ui: screenMap[item?.screen_name],
        }));
      setBannerScreensList(filterScreen);
    };
    const getUserTypeList = async () => {
      try {
        const data = await fetchUserTypeList();
        const modified_data = (data.response.user_type =
          data.response.user_type.map((type, index) => ({
            id: index,
            type: type,
          })));

        setUserTypes(modified_data);
      } catch (error) {}
    };
    getUserTypeList();
    getBannerScreensList();
  }, []);

  // const appScreenList = popupContentList?.map((item) => item.screen_name);
  // const screenListOptions = initialScreenListOptions?.filter(
  //   (item) => !appScreenList?.includes(item.value)
  // );

  const inputOnChange = (event) => {
    setInputDetails((prevState) => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });
  };
  // CREATE NEW MARQUEE FORM
  const postMarquee = useMutation({
    mutationFn: async () => {
      const res = await axiosConfig({
        method: "post",
        url: "appdashboard/announcement",
        data: {
          userid: USERID,
          announcement_name: marqueeName,
          announcement_description: marqueeDesc,
          user_type: marqueeType,
          activation_date: activateDate,
          expiry_date: expiryDate,
          screen: selectedScreenId,
        },
      });
      return res.data;
    },
    onSuccess: (data) => {
      setMarqueeList((prevState) => {
        return [...prevState, data.response];
      });

      setInputDetails(initialInputDetails);
      setSelectedScreenId("");
      setSelectedUser("");
      toast.success("Marquee created successfully!");
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });

  // HANDLE CREATE / POST NEW MARQUEE
  const handleCreateMarquee = (event) => {
    event.preventDefault();
    postMarquee.mutate();
  };

  // FETCH ALL MARQUEE LIST
  const marqueeQuery = useQuery({
    retry: false,
    refetchOnWindowFocus: false, // Prevent refetch on window focus
    refetchInterval: false, // Disable automatic refetching
    queryKey: ["marquee"], // dependency
    queryFn: () => fetchMarqueeList(USERID),
    onSuccess: (data) => {
      setMarqueeList(data.response);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });

  // DELETE MARQUEE
  const deleteMarquee = async (marquee_id) => {
    try {
      const res = await axiosConfig({
        method: "delete",
        url: `/appdashboard/announcement?announcement_id=${marquee_id}`,
        data: {
          userid: USERID,
        },
      });

      // update state if delete successfully
      setMarqueeList((prevState) => {
        const newMarqueeList = prevState.filter(
          (item) => item.id !== marquee_id
        );
        return newMarqueeList;
      });

      toast.error("Ticker deleted successfully!");
    } catch (error) {
      toast.error(error.message || "Something went wrong");
    }
  };

  // FETCH ALL TINYMCE CONTENT
  const fetchPopupQuery = useQuery({
    retry: false,
    refetchOnWindowFocus: false, // Prevent refetch on window focus
    refetchInterval: false, // Disable automatic refetching
    queryKey: ["popup-content"], // dependency
    queryFn: () => fetchPopupContent(USERID),
    onSuccess: (data) => {
      console.log(data, "data")
      setPopupContentList(data.response);
    },
    onError: (error) => {
      toast.error(error?.response?.data?.response || "Something went wrong");
    },
  });

  // create content handler
  const handleCreateContent = () => {
    setOpenTinyEditor(true);
  };

  useEffect(() => {
    const fetchScreenOptions = async () => {
      try {
        const response = await axiosConfig({
          method: "get",
          url: "/appdashboard/screens/",
        });

        console.log("screen", response);
        const data = response?.data?.response || [];

        // const activeScreenNames = data.filter((item) => item.is_active);
        setScreenOptions(data);
      } catch (error) {
        console.log(error, "error");
        const errMsg =
          error?.response?.data?.response ||
          error?.message ||
          "Failed to fetch screen options";
        console.error(errMsg);
        toast.error(errMsg);
      }
    };

    fetchScreenOptions();
  }, []);

  // marqueeName, marqueeDesc, activateDate, expiryDate
  const disableCreateBtn =
    !marqueeName ||
    marqueeName.trim() === "" ||
    !marqueeDesc ||
    marqueeDesc.trim() === "" ||
    !activateDate ||
    activateDate.trim() === "" ||
    !expiryDate ||
    expiryDate.trim() === "";
  return (
    <Box sx={{ p: 3, background: "#eef2f7", minHeight: "100vh" }}>
      {/* Page Header */}
      <Box
        sx={{
          background: "#04343a",
          borderRadius: "12px",
          boxShadow: "0 4px 20px rgba(4,52,58,0.3)",
          p: "20px 28px",
          mb: 3,
          display: "flex",
          alignItems: "center",
          gap: 2,
        }}
      >
        <CampaignIcon sx={{ color: "#fff", fontSize: 32 }} />
        <Box>
          <Typography sx={{ color: "#fff", fontWeight: 700, fontSize: "20px" }}>
            Create Marquee Form
          </Typography>
          <Typography sx={{ color: "rgba(255,255,255,0.65)", fontSize: "13px" }}>
            Manage announcements and marquee content
          </Typography>
        </Box>
      </Box>

      {/* Create Marquee Form Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          mb: 3,
          overflow: "hidden",
        }}
      >
        <Box sx={{ background: "#04343a", p: "12px 20px" }}>
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
            New Announcement
          </Typography>
        </Box>
        <Box sx={{ p: 3 }}>
          <form onSubmit={(e) => e.preventDefault()}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
              <TextField
                label="Title"
                name="marqueeName"
                size="small"
                fullWidth
                value={marqueeName}
                onChange={inputOnChange}
              />
              <TextField
                label="Description"
                name="marqueeDesc"
                size="small"
                fullWidth
                multiline
                rows={4}
                value={marqueeDesc}
                onChange={inputOnChange}
              />
              <TextField
                label="Select User Type"
                name="marqueeType"
                select
                size="small"
                fullWidth
                value={marqueeType}
                onChange={inputOnChange}
              >
                <MenuItem value="" disabled>Select User Type</MenuItem>
                <MenuItem value="Trial">Trial</MenuItem>
                <MenuItem value="Premium">Premium</MenuItem>
              </TextField>
              <TextField
                label="Select Screen"
                select
                size="small"
                fullWidth
                value={selectedScreenId}
                onChange={(e) => setSelectedScreenId(Number(e.target.value))}
              >
                <MenuItem value="" disabled>Select a screen</MenuItem>
                {screenOptions.map((screen) => (
                  <MenuItem key={screen.id} value={screen.id}>
                    {screen?.screen_name}
                  </MenuItem>
                ))}
              </TextField>
              <Box sx={{ display: "flex", gap: 2 }}>
                <TextField
                  label="Activate Date"
                  name="activateDate"
                  type="date"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={activateDate}
                  onChange={inputOnChange}
                  inputProps={{ min: new Date().toISOString().slice(0, 10) }}
                />
                <TextField
                  label="Expiry Date"
                  name="expiryDate"
                  type="date"
                  size="small"
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  value={expiryDate}
                  onChange={inputOnChange}
                  inputProps={{ min: new Date().toISOString().slice(0, 10) }}
                />
              </Box>
              <Box>
                <Button
                  type="button"
                  disabled={disableCreateBtn || postMarquee.isLoading}
                  onClick={handleCreateMarquee}
                  sx={{
                    background: "linear-gradient(135deg, #016551, #014d3d)",
                    color: "#fff",
                    fontWeight: 600,
                    borderRadius: "8px",
                    px: 4,
                    py: 1,
                    boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
                    "&:hover": {
                      background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)",
                      boxShadow: "0 6px 16px rgba(1,101,81,0.4)",
                    },
                    "&:disabled": { background: "#ccc" },
                  }}
                >
                  {postMarquee.isLoading ? (
                    <CircularProgress size={18} sx={{ color: "#fff" }} />
                  ) : (
                    "Create"
                  )}
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>

      {/* Announcements List Table Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          mb: 3,
          overflow: "hidden",
        }}
      >
        <Box sx={{ background: "#04343a", p: "12px 20px" }}>
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
            Announcements List
          </Typography>
        </Box>
        {marqueeQuery.isLoading ? (
          <Box display="flex" justifyContent="center" p={5}>
            <CircularProgress sx={{ color: "#016551" }} size={28} />
          </Box>
        ) : (
          <TableContainer component={Paper} elevation={0} sx={{ borderTop: "1px solid #eef2f7" }}>
            <Table>
              <TableHead>
                <TableRow>
                  {["Sr. No.", "Title", "Description", "User Type", "Screen Name", "Created At", "Expiry Date", "Actions"].map((label) => (
                    <TableCell
                      key={label}
                      sx={{
                        fontWeight: 700,
                        fontSize: "13px",
                        color: "#fff",
                        background: "#04343a",
                        borderBottom: "none",
                        padding: "12px 16px",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {marqueeList && marqueeList.length > 0 ? (
                  marqueeList.map((item, index) => (
                    <TableRow key={item.id} sx={{ "&:hover": { background: "#f0faf5" } }}>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{index + 1}</TableCell>
                      <TableCell>
                        <Typography sx={{ fontWeight: 600, color: "#016551", fontSize: "14px" }}>
                          {item.announcement_name}
                        </Typography>
                      </TableCell>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px", maxWidth: 200 }}>
                        {item.announcement_description}
                      </TableCell>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item?.user_type}</TableCell>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px" }}>{item.screen}</TableCell>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px", whiteSpace: "nowrap" }}>
                        {new Date(item.created_at).toDateString()}
                      </TableCell>
                      <TableCell sx={{ color: "#64748b", fontSize: "13px", whiteSpace: "nowrap" }}>
                        {new Date(item.expiry_date).toDateString()}
                      </TableCell>
                      <TableCell>
                        <IconButton
                          onClick={() => deleteMarquee(item.id)}
                          sx={{ color: "#e53935" }}
                          title="Delete"
                        >
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={8} align="center" sx={{ py: 5, color: "#94a3b8" }}>
                      No announcements available to display.
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Box>

      {/* Create Modal Content Card */}
      <Box
        sx={{
          background: "#fff",
          borderRadius: "12px",
          border: "1px solid #e2e8f0",
          boxShadow: "0 1px 6px rgba(0,0,0,0.07)",
          mb: 3,
          overflow: "hidden",
        }}
      >
        <Box sx={{ background: "#04343a", p: "12px 20px" }}>
          <Typography sx={{ color: "#fff", fontWeight: 600, fontSize: "14px" }}>
            Create Modal Content
          </Typography>
        </Box>
        <Box sx={{ p: 3, display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
          <TextField
            label="Choose Screen"
            select
            size="small"
            sx={{ minWidth: 200 }}
            value={selectedScreenInput}
            onChange={(event) => setSelectedScreenInput(event.target.value)}
          >
            <MenuItem value="" disabled>-- Select a Screen --</MenuItem>
            {bannerScreensList.map((item) => (
              <MenuItem key={item.id} value={item.screen_name}>
                {item.screen_name_ui}
              </MenuItem>
            ))}
          </TextField>

          <Select
            size="small"
            displayEmpty
            multiple
            value={selectedUser ? selectedUser.toString().split(",") : []}
            onChange={(event) => {
              const { value } = event.target;
              if (value.includes("all")) {
                const allSelected =
                  selectedUser &&
                  selectedUser.toString().split(",").length === userTypes.length;
                setSelectedUser(
                  allSelected ? "" : userTypes.map((user) => user.type).join(",")
                );
              } else {
                setSelectedUser(value.join(","));
              }
            }}
            renderValue={(selected) =>
              selected.length === 0 ? (
                <Typography sx={{ color: "#94a3b8", fontSize: "14px" }}>Select Audience</Typography>
              ) : (
                selected.join(", ")
              )
            }
            sx={{ minWidth: 200 }}
          >
            <MenuItem value="all">
              <Checkbox
                checked={
                  selectedUser &&
                  selectedUser.toString().split(",").length === userTypes?.length &&
                  userTypes?.length > 0
                }
              />
              <ListItemText primary="Select All" />
            </MenuItem>
            {userTypes?.map(({ id, type }) => (
              <MenuItem key={id} value={type}>
                <Checkbox checked={selectedUser?.toString().split(",").includes(type)} />
                <ListItemText primary={type} />
              </MenuItem>
            ))}
          </Select>

          <Button
            onClick={handleCreateContent}
            sx={{
              background: "linear-gradient(135deg, #016551, #014d3d)",
              color: "#fff",
              fontWeight: 600,
              borderRadius: "8px",
              px: 3,
              py: 1,
              boxShadow: "0 4px 12px rgba(1,101,81,0.3)",
              "&:hover": {
                background: "linear-gradient(135deg, #1db954 0%, #17a349 100%)",
                boxShadow: "0 6px 16px rgba(1,101,81,0.4)",
              },
            }}
          >
            Create
          </Button>
        </Box>
      </Box>

      {/* CONTENT DISPLAY TABLE */}
      <TinyMCEContentTable
        tableRowData={popupContentList}
        userID={USERID}
        setOpenTinyEditor={setOpenTinyEditor}
        setPopupContentList={setPopupContentList}
        editorRef={editorRef}
      /> 

      {/* TinyMCE Modal Popup for creating new content */}
      <MuiModal open={openTinyEditor} setOpen={setOpenTinyEditor}>
        <TinyMCEEditor
          selectedScreen={selectedScreenInput}
          selectedUser={selectedUser}
          setPopupContentList={setPopupContentList}
          userID={USERID}
          crudType="create"
          editorRef={editorRef}
          setOpen={setOpenTinyEditor}
        />
      </MuiModal>

      {/* REACT HOT TOAST */}
      <ReactHotToaster />
    </Box>
  );
};
export default CreateMarqueeForm;
// UTILITY FUNCTIONS
export const fetchMarqueeList = async (USERID) => {
  if (!USERID) return;

  const res = await axiosConfig({
    method: "get",
    // url: `/appdashboard/announcement?userid=${USERID}&marquee=true`,
    url: `/appdashboard/announcement?userid=${USERID}`,
    data: {},
  });

  return res.data;
};

export const fetchPopupContent = async (USERID) => {
  if (!USERID) return;

  const res = await axiosConfig({
    method: "get",
    url: `/appdashboard/popup_message/admin`,
    data: {},
  });

  return res.data;
};
